import {Outlet, useLocation} from 'react-router';
import {motion} from 'framer-motion';
function FullLayout() {
  const {pathname} = useLocation();
  return (
    <>
      <motion.div
        key={pathname}
        initial={{opacity: 0, x: '100%'}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: '-100%'}}
        transition={{duration: 0.2}}
        className="p-3 w-100 vh-100"
      >
        <Outlet />
      </motion.div>
    </>
  );
}

export default FullLayout;
